<span
  class="badge-tile"
  [class.badge-tile-earned]="isEarned"
  [class.badge-tile-art]="hasArt"
  [style.width.px]="px"
  [style.height.px]="px"
  [style.background-color]="hasArt ? null : background"
>
  <!-- Uploaded SVG is the whole badge; locked ones are grayed out in CSS. -->
  <img *ngIf="hasArt; else legacyIcon" class="badge-tile-img" [src]="badge.iconUrl" alt="" draggable="false" />
  <ng-template #legacyIcon>
    <i class="bi" [ngClass]="iconClass" [style.color]="iconColor" [style.font-size.px]="px * 0.42"></i>
  </ng-template>
  <!-- Progress: a full-color copy of the badge, revealed from the bottom up. -->
  <span
    class="badge-tile-fill"
    *ngIf="hasFill"
    [style.clip-path]="fillClipPath"
    [style.background-color]="hasArt ? null : fillColor"
  >
    <img *ngIf="hasArt; else legacyFillIcon" class="badge-tile-img" [src]="badge.iconUrl" alt="" draggable="false" />
    <ng-template #legacyFillIcon>
      <i class="bi" [ngClass]="iconClass" [style.color]="'#ffffff'" [style.font-size.px]="px * 0.42"></i>
    </ng-template>
  </span>
  <span class="badge-tile-count" *ngIf="repeatCount > 0" [style.font-size.px]="px >= 64 ? 11 : 9">
    &times;{{ repeatCount }}
  </span>
</span>
